import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const DELETE_PRODUCT = {
    typeModal: TYPE_MODAL.NOTIFICATION,
    title: '¿Desea eliminar el producto de su lista?',
    valueButton: 'Eliminar',
    color: CONFIRM_COLOR.WARN,
    icon: CONFIRM_ICONS.CANCEL
  };
